<template>
  <v-dialog
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    v-model="opened"
  >
    <v-card flat>
      <v-card-text class="align-center">
        <v-icon class="success--text" size="50">thumb_up</v-icon>
        <v-layout
          column
          align-center
          class="subheading pa-2 success--text font-weight-bold"
        >
          Well Done!
        </v-layout>
        <v-divider class="my-3" />

        <v-layout column align-center class="text-xs-left">
          You've signed all pages.
        </v-layout>

        <v-layout
          v-if="hasIncompletedSignatures"
          column
          align-center
          class="my-0 mt-2"
        >
          Please remind {{ namesOfIncompletedSignatures.join(', ') }} to sign
          the tax return, which has been to sent to
          {{ namesOfIncompletedSignatures.length === 1 ? 'his/her' : 'their' }}
          email
          {{
            namesOfIncompletedSignatures.length === 1 ? 'address' : 'addresses'
          }}.
        </v-layout>

        <v-divider class="my-3" />

        <v-layout align-center>
          <v-btn
            v-if="hasNextStep"
            outline
            block
            color="primary"
            class="text-none mr-2"
            @click="$emit('go-to-next-step')"
          >
            Next
          </v-btn>

          <v-btn
            v-else
            outline
            block
            color="primary"
            class="text-none mr-2"
            @click="goToDashboard"
          >
            Go to Dashboard
          </v-btn>
          <v-btn
            v-if="k1DistributionApplicable"
            outline
            block
            color="primary"
            class="text-none mr-2"
            @click="goToK1Distribution"
          >
            Distribute K-1 Packages
          </v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import uniq from 'lodash/uniq';
import FirmPreferenceMixins from '@/mixins/FirmPreferenceMixins';

export default {
  mixins: [FirmPreferenceMixins],

  props: {
    opened: {
      type: Boolean,
    },

    taxReturn: {
      type: Object,
    },

    hasNextStep: {
      type: Boolean,
    },
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      currentFirm: 'currentFirm',
    }),

    incompletedSignatures() {
      return this.taxReturn.e_sign_forms
        .filter(form => !form.wetSignaturesRequired)
        .flatMap(form => {
          return form.signatures.filter(signature => !signature.signatureData);
        });
    },

    namesOfIncompletedSignatures() {
      return uniq(
        this.incompletedSignatures.map(signature => {
          return signature.name;
        }),
      );
    },

    hasIncompletedSignatures() {
      return this.incompletedSignatures.length > 0;
    },

    k1DistributionApplicable() {
      return (
        this.isEmbeddedInNext &&
        this.taxReturnK1DistributionEnabled &&
        this.taxReturn.k1_distribution_status !== 'not_applicable' &&
        this.taxReturn.k1_packages.length > 0
      );
    },
  },

  methods: {
    goToK1Distribution() {
      window.location.href = '/?k1-distribution-id=' + this.taxReturn.id;
    },

    goToDashboard() {
      if (this.isEmbeddedInNext) {
        window.location.href = '/';
      } else if (this.$route.params.hash) {
        this.$router.push(`/${this.$route.params.hash}`);
      } else {
        this.$router.push(`/?companyId=${this.taxReturn.company_id}`);
      }
    },
  },
};
</script>
